import { FC, Fragment } from 'react';
import { sum } from 'shared-utils';

import { ItemDescription } from '@common/features/List/ListItem.styles';
import rewriteHttp from '@utils/rewriteHttp';

import { OptionDivider, SpaImageMobile, SpaImageWrapperMobile } from '../ExperiencesGroup.styles';

import { ExperienceDetails } from '../../ExperienceDetails';
import { FormStep, PackagesFormValues } from '../../../types';
import { useFormContext } from 'react-hook-form';
import { SpaEntityType } from 'shared-types/Spa';
import { ExperienceDetailsClasses } from '../../ExperienceDetails/ExperienceDetailsClasses';
import { usePackageConfiguration } from '../../../contexts';

interface Props {
  selectionGroup: Omit<FormStep, 'step' | 'type'>;
  allOptionsIncluded?: boolean;
  spaExperiences: Partial<SpaEntityType>[];
  plusMinusSpaOption: any;
  totalGuests: number;
  dayNumber: number;
}
export const ExperiencesGroupOptionsMobile: FC<Props> = ({
  selectionGroup,
  allOptionsIncluded,
  spaExperiences,
  plusMinusSpaOption,
  totalGuests,
  dayNumber,
}) => {
  // Get property from context
  const { property } = usePackageConfiguration();

  const { watch } = useFormContext<PackagesFormValues>();
  const selectedExperiences = watch('selectedExperiences');

  const selectionsInOptionGroup = (selectedExperiences || []).filter(
    (exp) => exp.optionGroupId === selectionGroup.optionGroupId && exp.dayNumber === dayNumber
  );
  const totalNumberOfSelectionsInGroup = sum(selectionsInOptionGroup, (option) => option.count);
  const maxSelectionsForGroup = totalGuests * (selectionGroup.selectionsRequired || 1);

  return (
    <>
      {spaExperiences?.map((exp) => {
        const optionId = selectionGroup.options?.find((g) => g.id === exp.id)?.optionId;
        const spaOptionCount =
          selectedExperiences?.find(
            (option) =>
              option.id === exp.id && option.optionId === optionId && option.dayNumber === dayNumber
          )?.count || 0;
        const experienceDetailProps = {
          entityType: selectionGroup.experienceType,
          id: Number(exp?.id),
          language: property.defaultLanguage,
          propertyId: property.id,
          count: spaOptionCount || 0,
          plusMinusSpaOption: plusMinusSpaOption,
          disabledMinus: spaOptionCount === 0,
          disabledPlus:
            spaOptionCount >= totalGuests ||
            totalNumberOfSelectionsInGroup >= maxSelectionsForGroup,
          allOptionsIncluded,
          unavailable: exp?.unAvailable,
          optionId: Number(optionId),
          spaEntity: exp,
        };
        return (
          <Fragment key={exp.id}>
            <div data-unavailable={exp?.unAvailable}>
              {selectionGroup.experienceType === 'spa-classes' ? (
                <div />
              ) : (
                <SpaImageWrapperMobile isFullDim>
                  <SpaImageMobile
                    url={rewriteHttp(exp?.image?.url || exp?.imageGallery?.[0].url)}
                  />
                </SpaImageWrapperMobile>
              )}
              <ItemDescription>
                {selectionGroup.experienceType === 'spa-classes' ? (
                  <ExperienceDetailsClasses {...experienceDetailProps} />
                ) : (
                  <ExperienceDetails {...experienceDetailProps} />
                )}
              </ItemDescription>
            </div>
            <OptionDivider />
          </Fragment>
        );
      })}
    </>
  );
};
